import { Product } from 'models/product'
import produce from 'immer'

export default (product: Product): Product => {
    return produce(product, (newProduct) => {})
}
